import React from 'react'
import { has } from 'lodash-es'
import { getNonResidentText } from '../helpers/logic'

function EventZone({
  productId,
  zoneInstance,
  availableSpots,
  selected,
  onSelectZone,
  isDynamicPricing
}) {
  const zoneId = `zone-${zoneInstance.zoneId}`
  const zoneIsMembersOnly =
    !has(zoneInstance.pricing, 'nonMember') &&
    has(zoneInstance.pricing, 'member')
      ? '*Members Only'
      : ''
  return (
    <li className="radio">
      <label
        className='cursor-pointer'
        htmlFor={zoneId}
      >
        <input
          type="radio"
          onChange={onSelectZone}
          id={zoneId}
          name={`event-${productId}`}
          checked={selected}
          disabled={availableSpots === 0}
          className='cursor-pointer'
        />
        <span className={isDynamicPricing ? 'font-bold' : ''}>
          {zoneInstance.description} {zoneIsMembersOnly}
          {isDynamicPricing && (
            <span className="font-light">
              <br />
              {getNonResidentText(zoneInstance)}
            </span>
          )}
        </span>
      </label>
    </li>
  )
}

export default EventZone
